import { useEffect, useState } from 'react'

import { stringIsFalsy } from '../utils/string'

const QUERY_OVERRIDE_KEY = 'isAfterHours'
const SESSION_OVERRIDE_KEY = 'uma:isAfterHours'
const IS_SELF_ENROLL_ON = process.env.GATSBY_CAN_ENROLL_NOW === 'true'
const TIME_CLOSE_UTC = 2 // east coast 9pm (21 + 5 hours for daylight UTC offset)
const TIME_OPEN_UTC = 14 // east coast 9am (9 + 5 hours for daylight UTC offset)

function useAfterHours(): boolean | null {
  const [isAfterHours, setIsAfterHours] = useState<boolean | null>(null)

  useEffect(() => {
    // get the query override if it's there
    const searchParams = new URLSearchParams(window.location.search)
    const queryOverride = searchParams.get(QUERY_OVERRIDE_KEY)

    // if override and truthy (or has key only, no value), set true
    if (queryOverride !== null && (queryOverride === '' || !stringIsFalsy(queryOverride))) {
      sessionStorage.setItem(SESSION_OVERRIDE_KEY, 'true')
    }

    // if override and falsy, set false
    else if (queryOverride !== null && stringIsFalsy(queryOverride)) {
      sessionStorage.setItem(SESSION_OVERRIDE_KEY, 'false')
    }

    // check session value
    const sessionOverride = sessionStorage.getItem(SESSION_OVERRIDE_KEY)

    // if session value and true, set true
    if (sessionOverride && sessionOverride === 'true') {
      setIsAfterHours(true)
    }

    // if session value and false, set false
    else if (sessionOverride && sessionOverride === 'false') {
      setIsAfterHours(false)
    }

    // if no session value, look to UTC time
    else {
      const timeUTC = new Date().getUTCHours()
      setIsAfterHours(IS_SELF_ENROLL_ON && timeUTC >= TIME_CLOSE_UTC && timeUTC < TIME_OPEN_UTC)
    }
  }, [])

  return isAfterHours
}

export default useAfterHours
